// @flow
export const filterId: 'sort' = 'sort';
